module.exports = __webpack_public_path__ + "img/voucher7.61b1104f.png";